import React from 'react';
import PageBanner from '../components/PageBanner';

const HIGHLIGHTS = [
  { value: '50K+', label: 'عميل نشط شهرياً' },
  { value: '13', label: 'فئة منتجات رئيسية' },
  { value: '+40%', label: 'نمو سنوي في الطلبات' },
  { value: '2022', label: 'سنة التأسيس' },
];

const REPORTS = [
  { title: 'التقرير المالي السنوي 2025', size: 'PDF · 2.4MB' },
  { title: 'عرض تقديمي للمستثمرين', size: 'PDF · 5.1MB' },
  { title: 'تقرير الحوكمة والاستدامة', size: 'PDF · 1.8MB' },
];

const Investors = () => {
  return (
    <div dir="rtl">
      <PageBanner
        eyebrow="علاقات المستثمرين"
        title="المستثمرون"
        subtitle="معلومات مالية وتقارير دورية لشركاء وداعمي MEME STORE."
      />

      <div className="container mx-auto px-4 py-14">

        {/* أرقام رئيسية */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-5 mb-16">
          {HIGHLIGHTS.map((h) => (
            <div key={h.label} className="bg-[#F6F5F2] rounded-2xl p-6 text-center">
              <h3 className="text-3xl font-extrabold text-[#1B1B1F]">{h.value}</h3>
              <p className="text-sm text-gray-500 mt-1">{h.label}</p>
            </div>
          ))}
        </div>

        <div className="grid lg:grid-cols-3 gap-10">

          <div className="lg:col-span-2">
            <h2
              className="text-2xl font-bold text-[#1B1B1F] mb-4"
              style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif" }}
            >
              نظرة عامة
            </h2>
            <p className="text-gray-600 leading-8 mb-4">
              منذ انطلاقها، تسعى MEME STORE لتكون الوجهة الأولى للتسوق الإلكتروني في المنطقة،
              من خلال الاستثمار المستمر في تجربة العميل، وسلاسل التوريد، والتقنية.
            </p>
            <p className="text-gray-600 leading-8">
              نلتزم بالشفافية الكاملة مع شركائنا وداعمينا الماليين، ونوفر هنا آخر التقارير
              والمستندات المتعلقة بأداء الشركة.
            </p>
          </div>

          <div className="bg-white border border-gray-100 rounded-2xl p-6 shadow-[0_2px_10px_rgba(27,27,31,0.05)] h-fit">
            <h3 className="font-bold text-[#1B1B1F] mb-4">التقارير والمستندات</h3>

            <ul className="space-y-3">
              {REPORTS.map((report) => (
                <li key={report.title}>
                  <button
                    type="button"
                    className="w-full flex items-center justify-between gap-3 text-right px-4 py-3 rounded-xl bg-[#F6F5F2] hover:bg-[#F2B705]/20 transition-colors"
                  >
                    <span>
                      <span className="block text-sm font-bold text-[#1B1B1F]">
                        {report.title}
                      </span>
                      <span className="block text-xs text-gray-500 mt-0.5">{report.size}</span>
                    </span>
                    <span aria-hidden="true" className="text-[#1B1B1F]">↓</span>
                  </button>
                </li>
              ))}
            </ul>

            <p className="text-xs text-gray-400 mt-5 leading-6">
              لأي استفسار خاص بالمستثمرين تواصل معنا على{' '}
              <a href="mailto:investors@memestore.sa" className="text-[#1B1B1F] font-bold underline">
                investors@memestore.sa
              </a>
            </p>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Investors;
